"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyContactStatus = void 0;
var CompanyContactStatus;
(function (CompanyContactStatus) {
    CompanyContactStatus["Active"] = "active";
    CompanyContactStatus["Invited"] = "invited";
    CompanyContactStatus["Disabled"] = "disabled";
})(CompanyContactStatus = exports.CompanyContactStatus || (exports.CompanyContactStatus = {}));
//# sourceMappingURL=CompanyContact.js.map